<template>
    <div id="news_page" class="page-class">
        <div class="page-wrapper">
            <div class="page-content">
                <NavBarLogo
                    :userType="userType"
                    v-if="isList" />
                <NavbarDetail
                    :lbl="lbl.detail"
                    :isShowInfo="false"
                    :navName="navbarName"
                    :userType="userType"
                    :profile="profile"
                    :userPoint="point"
                    :busNav="busNav"
                    v-if="!isList"
                    @clickBack="clickBack" />
                <keep-alive>
                    <router-view :key="$route.fullPath"></router-view>
                </keep-alive>
                <TabBar
                    id="news_list"
                    :lblTab="lbl.tabbar"
                    :theme="userType"
                    tabActive="news"
                    v-if="isList" />
            </div>
            <div class="page-bg page-bg-white"></div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import NavbarDetail from '@/components/Layout/NavBar/NavBarDetail.vue';
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
import TabBar from "@/components/Layout/TabBar/TabBar.vue";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: 'News',
    mixins: [AccountMixin, LocaleMixin],
    components: {
        NavbarDetail,
        NavBarLogo,
        TabBar
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    watch: {
        $route(to) {
            this.setIsList(to);
        }
    },
    data: function () {
        return {
            //config
            isList: true,
            isShowNavInfo: true,

            //modal
            busNav: new Vue(),
            navbarName: '',

            trackingService: new TrackingService(this),
            trackingScreenName: 'newslist',
            trackingEventCategory: 'newsdetail_page'
        };
    },
    created: function () {
        this.setIsList(this.$route);

        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        //event
        clickBack: function () {
            this.trackingService.event(this.trackingEventCategory, 'click_back', null, null)
            
            if (this.isList)
                this.$router.push('/');
            else
                this.$router.back();
        },
        setIsList: function (to) {
            this.isList = (to.name == 'newslistpage');
            this.navbarName = this.isList ? this.lbl.reward.title_product : this.lbl.detail.navbar_news_name;
        }
    }
}
</script>
